import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AlertCircle } from 'lucide-react';
import Aurora from '../components/UI/Aurora';
import ProfileCard from '../components/UI/ProfileCard';

const Login: React.FC = () => {
  const { currentUser, signInWithGoogle, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const params = new URLSearchParams(location.search);
  const errorParam = params.get('error');

  React.useEffect(() => {
    if (currentUser) {
      if (currentUser.email?.endsWith('@groupesavoie.com')) {
        navigate('/');
      }
    }
  }, [currentUser, navigate]);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4 relative overflow-hidden">
      <Aurora
        colorStops={["#6B9A3F", "#8CBF58", "#5A8335"]}
        blend={0.5}
        amplitude={1.0}
        speed={0.5}
      />
      
      <div className="relative z-10">
        <ProfileCard
          name="Groupe Savoie"
          title="Plateforme Média"
          handle="groupesavoie"
          status="Connectez-vous pour continuer"
          contactText="Se connecter avec Google"
          avatarUrl="/assets/images/Component 10.png"
          showUserInfo={true}
          enableTilt={true}
          onContactClick={signInWithGoogle}
        />

        {(error || errorParam === 'unauthorized') && (
          <div className="mt-4 bg-red-500/20 border border-red-200/20 text-red-100 px-4 py-3 rounded-lg flex items-start">
            <AlertCircle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
            <div>
              <p className="font-medium">Erreur d'authentification</p>
              <p className="text-sm">
                {errorParam === 'unauthorized'
                  ? "Seules les adresses email @groupesavoie.com sont autorisées."
                  : error || "Une erreur est survenue lors de la connexion."}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;